import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ChannelFilter extends Component {
    state = {
        channelLists:[],
        channelValue:null,
        channelLoading: true
    };
    componentDidMount(){
        this.get_channel(this.props.channel_type);
    }

    resetChannelFilter(){
        this.setState({
        channelValue: [],
        })
    }
     get_channel(channel_type){
        var data = {
                channel_type:channel_type,

            }
        this.setState({
            channelLists:[]
        })
        axios.post(config.get('API_URL')+'/CampaignModule/get_campaign_channels/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((type, index) => {
                    this.state.channelLists.push({value: type.channel_code, label: type.channel})
                });
            }
        });
     }
     changechannel(optionSelected){
        let value='';
        let channelArray = [];
        if(optionSelected.length < 1){
            value = null;
            channelArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                channelArray.push(mids.value)
                var index = this.state.channelLists.findIndex(obj => obj.value==mids.value);
                this.state.channelLists.move(index,0).join(',');

            });
        }
        this.props.onSelectChannel(optionSelected,channelArray);
        this.setState({
            channelValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="product"
            isMulti
            value={this.state.channelValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changechannel.bind(this)}
            options={this.state.channelLists}
            placeholderButtonLabel="Select [Channel]"
        />
        );

    }
}
export default ChannelFilter;